const component = require('../component/component');

const optionsComponent = Object.assign({}, component, {
    filterDependablesWhenHidden: true,
    options: [],
    optionAttribute: 'id',
    parentAttribute: null,
    selectedValue: null,
    dependables: [],
    autoUpdate: false,

    init: function () {
        component.init.call(this);

        this.initOptions();

        if (this.autoUpdate) {
            this.changeEvents.forEach((eventName) => {
                this.element.addEventListener(eventName, () => { this.doAutoUpdate(); });
            });
        }
    },

    inited: function () {
        this.filterDependables();
    },

    filterDependables: function () {
        if (!this.filterDependablesWhenHidden && this.isHidden) {
            return true;
        }
        
        if (this.parentAttribute !== null) {
            let parentValues = [];

            if (this.optionAttribute === 'id') {
                let currentSelectedValues = this.getValue();
                if (!Array.isArray(currentSelectedValues)) {
                    parentValues = [currentSelectedValues];
                } else {
                    parentValues = currentSelectedValues;
                }
            } else {
                for (let i = 0; i < this.options.length; i++) {
                    let option = this.options[i];

                    let currentSelectedValues = this.getValue();

                    if (!Array.isArray(currentSelectedValues)) {
                        currentSelectedValues = [String(currentSelectedValues)];
                    }

                    if (currentSelectedValues.includes(String(option.id))) {
                        parentValues.push(option[this.optionAttribute]);
                        break;
                    }
                }
            }

            for (let componentId in this.hm.app.components) {
                let component = this.hm.app.components[componentId];

                let elementKey = component.elementKey();
                let basicComponentId = '';

                if (elementKey !== false) {
                    basicComponentId = componentId.substring(0, componentId.length - elementKey.length - 1);
                }

                if (componentId !== this.id && (this.dependables.length === 0 || this.dependables.includes(componentId) || this.dependables.includes(basicComponentId + '_allItems'))) {
                    parentValues.forEach((parentValue) => {
                        component.filterHide(this.parentAttribute, String(parentValue));
                    });
                }
            }
        }
    },

    initOptions: function () {
        //inited from data-zit attributes
    },

    doAutoUpdate: async function () {
        let data = {
            configHash: this.configHash,
            componentAction: 'autoUpdate',
            autoUpdateValue: this.getValue()
        };

        let response = await this.hm.app.fetchJson('components', 'main', data);

        if (typeof response._redirect !== typeof undefined) {
            window.location.assign(response._redirect);
        }

        this.hm.app.readMessages();

        let ev = new CustomEvent('autoUpdated', { response: response });
        this.element.dispatchEvent(ev);
    },
});

module.exports = optionsComponent;